import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Subtract } from 'utility-types';

export interface IWithArticleIdProps {
  articleId: string;
}

const withArticleId = <P extends IWithArticleIdProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, IWithArticleIdProps> & RouteComponentProps<{ id: string }>
> => props => {
  return <Component articleId={props.match.params.id} {...props} />;
};

export default withArticleId;



// WEBPACK FOOTER //
// ./src/enhancers/withArticleId.tsx